import Button from "../ui_components/button/button";
import {
    Modal,
    ModalActions as ModalActionsE,
    ModalContent,
    ModalHeader as ModalHeaderE,
    ModalProps,
} from "../ui_components/modal";
import PageDimmer from "../ui_components/dimmer/PageDimmer";
import React from "react";
import styled, { css } from "styled-components";
import { breakpoints, theme } from "../theme";

const noop = () => {
    /* ignore */
};

export interface ConfirmationModalProps
    extends Pick<
        ModalProps,
        | "uiActive"
        | "uiOnRequestClose"
        | "className"
        | "uiOnClose"
        | "uiTransitionTimeout"
        | "uiCloseOnEsc"
        | "uiCloseOnOutsideClick"
    > {
    /**
     * Modal header
     */
    uiHeader?: string;
    /**
     * Decline button label
     */
    uiDeclineLabel?: string | false;
    /**
     * Accept button label
     */
    uiAcceptLabel?: string | false;
    /**
     * Close modal when pressing Esc
     * @default true
     */
    uiCloseOnEsc?: boolean;
    /**
     * Close modal on outside click
     * @default true
     */
    uiCloseOnOutsideClick?: boolean;
    /**
     * Class name
     */
    className?: string;
    /**
     * Footer Class name
     */
    footerClassName?: string;
    /**
     * Child
     */
    children?: React.ReactNode;
    /**
     * Confirmation callback
     */
    uiOnConfirm(res?: unknown): void;

    /**
     * Edit Work Order condition
     */
    workOrderEditMode?: boolean;

    /**
     * Cancel editing Work Order
     */
    cancelEditing?(): void;
}

const ConfirmationContent = styled(ModalContent)`
    display: flex !important;
    flex-flow: row wrap !important;
    align-items: center !important;
    color: ${theme.colors.grayRGBA} !important;
`;

const StyledModal = styled(Modal)`
    max-width: 500px !important;
    width: 100% !important;
    border-radius: 0.5rem !important;
    border: solid ${theme.colors.grayRGBA} 1px !important;
    ${breakpoints.down(
        "sm",
        css`
            max-width: 90% !important;
        `
    )};
`;

const ModalHeader = styled(ModalHeaderE)`
    color: ${theme.colors.primary} !important;
    border-bottom: none !important;
    padding-bottom: 0.25rem !important;
`;

const ModalHeaderDivider = styled.div`
    height: 10px !important;
    width: calc(100% - 40px) !important;
    margin: 0 auto !important;
    background: ${theme.colors.divider} !important;
`;

const ModalActions = styled(ModalActionsE)`
    border-bottom-left-radius: 0.5rem !important;
    border-bottom-right-radius: 0.5rem !important;
    justify-content: space-between;
    padding: 0.7rem 1rem !important;
`;

const BasicButton = styled(Button)`
    // width: 130px;
    box-shadow: none !important;
    border: 1px solid #c6c6c6 !important;
    border-radius: 0.5em !important;
    display: block !important;
`;

const ConfirmButton = styled(BasicButton)`
    margin-left: ${(props) =>
        props.className === "pop-up" ? "auto" : "initial"} !important;
`;

const CancelButton = styled(BasicButton)`
`;

/**
 * Simple confirmation modal
 */
export const ConfirmationModal: React.FC<ConfirmationModalProps> = (props) => {
    const leftButtonAction = props.workOrderEditMode ? props.uiOnRequestClose : props.uiOnRequestClose
    const rightButtonAction = props.workOrderEditMode ? props.uiOnConfirm : props.uiOnConfirm
    return (
        <StyledModal
            className={props.className}
            uiActive={props.uiActive}
            uiOnRequestClose={noop}
            uiDefaultSizes={false}
            uiOnClose={props.uiOnClose}
            uiTransitionTimeout={props.uiTransitionTimeout}
            uiCloseOnOutsideClick={props.uiCloseOnOutsideClick}
            uiCloseOnEsc={props.uiCloseOnEsc}
        >
            {props.uiAcceptLabel === "Setup" &&
                props.uiHeader === "Setup Needed" && <PageDimmer uiActive />}
            <ModalHeader>{props.uiHeader}</ModalHeader>
            <ModalHeaderDivider />
            <ConfirmationContent>{props.children}</ConfirmationContent>
            <ModalActions className={props.footerClassName}>
                {props.uiDeclineLabel && (
                    <CancelButton
                        className="cancel_btn"
                        id="decline"
                        uiColor="secondary"
                        onClick={leftButtonAction}
                    >
                        {props.uiDeclineLabel}
                    </CancelButton>
                )}
                {props.uiAcceptLabel && (
                    <ConfirmButton
                        id="confirm"
                        uiColor="primary"
                        onClick={rightButtonAction}
                        className={`confirm_btn ${props.className}`}
                    >
                        {props.uiAcceptLabel}
                    </ConfirmButton>
                )}
            </ModalActions>
        </StyledModal>
    );
};

ConfirmationModal.defaultProps = {
    uiHeader: "Please confirm the action",
    uiAcceptLabel: "Yes",
    uiDeclineLabel: "No",
};
